<template>
  <v-container>
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        md="6"
        lg="4"
        align="center"
        class="pt-100"
      >
        <v-autocomplete
          v-model="customer"
          :items="customers"
          :loading="isLoading"
          reverse
          light
          label="Choisir un client"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        md="6"
        lg="4"
        align="right"
      >
        <v-btn 
          color="success"
          block
          @click="setCustomer()"
        >
          <v-icon right dark class="mr-2">mdi-check</v-icon>
          Valider
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // EVENTS
  import { AUTH_LOGOUT } from '@/store/actions/auth'
  import { SET_CUSTOMER } from '@/store/actions/auth'
  // REPOSITORIES
  import { RepositoryFactory } from '@/repositories/RepositoryFactory'
  const UsersRepository = RepositoryFactory.get('users')
  
  export default {
    name: 'ChooseCustomer',

    data: () => ({
      customers: [],
      isLoading: false,
      customer: '',
    }),

    methods: {
      async getCustomers() {
        this.isLoading = true
        await UsersRepository
          .getCustomers()
          .then(response => {
            this.isLoading = false
            this.customers    = response.data
            EventBus.$emit(LOADED)
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      },
      setCustomer() {
        let wantedCustomer = this.customers.find(cust => cust.value === this.customer)
        this.$store
          .dispatch(SET_CUSTOMER, wantedCustomer)
          .then(() => {
            this.$router.push({ name: 'ListReference' })
          })
          .catch(e => {
            if (error.response) {
              if (error.response.status == 403) {
                this.$store
                  .dispatch(AUTH_LOGOUT)
                  .then(() => {
                    this.$router.push('/login').catch(err => {})
                  })
              }
            }
          })
      }
    },

    created() {
      this.getCustomers()
      if (this.$store.getters.hasCustomer) {
        this.customer = this.$store.getters.getCustomer.value
      }
    }
  }
</script>

<style scoped>
  .pt-100 {
    padding-top: 100px !important;
  }
</style>